import { compose, prop } from 'ramda'
import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../packages/kiti/components/presentation/Text'
import { useTriggerCallState } from './_load/TriggerCallLoader'
import { useTriggerCallsActions } from '../_actions/triggerCallsActions'
import DropdownLink from '../../../components/navigation/DropdownLink'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsMenu from '../../../components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation(['triggerCalls', 'common'])
  const triggerCall = useTriggerCallState()?.triggerCall

  const [options] = useTriggerCallsActions(triggerCall, null, { hide: ['seeDetails'] })

  const updatedAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('updatedAt'))(triggerCall)

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color="dark1" noMargin>
            {t('triggerCalls:triggerFired')}
          </Title>
          <SmallText color="dark3">
            {t('common:createdAt')} {updatedAt}
          </SmallText>
        </Col>

        <Col flex={1}></Col>

        <Col>
          <RefetchingIndicator />
        </Col>

        {!!options?.length && (
          <Col>
            <DropdownLink
              fromRight
              options={options}
              actionContent={<Icon name="BsThreeDotsVertical" size={1.4} />}
              t={t}
            />
          </Col>
        )}
      </Grid>

      <Separator weight={6} />

      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
